import { useCallback, useEffect, useState } from 'react';

const LNB_WIDTH = 264;
const CONTENT_MIN_WIDTH = 728;
const SEPARATOR_WIDTH = 4;
const PANEL_MIN = 300;

/** viewport 40% 또는 (viewport - LNB - Content최소 - Separator) 중 작은 값 */
const calcMaxSize = (viewportWidth: number): number => {
  const available = viewportWidth - LNB_WIDTH - CONTENT_MIN_WIDTH - SEPARATOR_WIDTH;
  const fortyPercent = Math.floor(viewportWidth * 0.4);

  return Math.max(PANEL_MIN, Math.min(available, fortyPercent));
};

type TypePanelSizeConfig = {
  defaultSize: string;
  minSize: string;
  maxSize: string;
  resizable: boolean;
};

const useSmartSearchPanelSize = (): TypePanelSizeConfig => {
  const calculate = useCallback((): TypePanelSizeConfig => {
    const vw = window.innerWidth;

    // 1441px 이상: 리사이즈 가능
    if (vw >= 1441) {
      const max = calcMaxSize(vw);
      return {
        defaultSize: '400px',
        minSize: `${PANEL_MIN}px`,
        maxSize: `${max}px`,
        resizable: true,
      };
    }

    // 1200~1440px: 고정 300px
    return {
      defaultSize: `${PANEL_MIN}px`,
      minSize: `${PANEL_MIN}px`,
      maxSize: `${PANEL_MIN}px`,
      resizable: false,
    };
  }, []);

  const [config, setConfig] = useState<TypePanelSizeConfig>(calculate);

  useEffect(() => {
    const handleResize = () => setConfig(calculate());
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [calculate]);

  return config;
};

export default useSmartSearchPanelSize;
